import { LoaderCircle } from 'lucide-react';
import styled from 'styled-components';

export const ProcessingBar = styled.div.attrs({
  className: 'fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card p-3',
  role: 'status',
  'data-recording-bottom-bar': true,
})``;

export const ProcessingBarContent = styled.div.attrs({
  className: 'mx-auto flex w-full max-w-6xl items-center gap-3',
})``;

export const ProcessingIcon = styled(LoaderCircle).attrs({
  className: 'size-5 shrink-0 animate-spin text-foreground',
  'aria-hidden': true,
})``;

export const ProcessingTitle = styled.p.attrs({
  className: 'text-sm font-semibold text-foreground',
})``;

export const ProcessingDescription = styled.p.attrs({
  className: 'text-sm text-muted-foreground',
})``;
